<!--psPace报警-->
<template>
    <div v-show="isShow" :style="domStyle">
        <span class="header" ref="mycolor" >
            <Table :border="showBorder" highlight-row ref="tables" size="small" :loading="loading" @on-row-dblclick="doblueClick" @on-current-change="" :row-class-name="rowClassName" :columns="columns" :data="alarmData" :disabled-hover="true" :height="tableHeight"></Table>
            <Page :total="dataCount" :current="currentPage" :page-size="pageSize" size="small" class="paging" @on-change="changepage"></Page>
            <audio ref="audio" loop="loop" autoplay="autoplay"></audio>
        </span>
        <Modal v-model="alarmModal" :title="alarmModalTitle" :mask-closable="false" draggable class-name="vertical-center-modal">
            <Card class="clearfix" :dis-hover="true" :bordered="false">
                <Form v-for="item in this.column" :key="item.key" label-position="right" :label-width="100">
                    <FormItem :label="item.title" style="margin-bottom:5px;float:left;">
                        <i-input v-if="item.key != 'AlarmAckUserName' && item.key != 'contentStr' " style="width:330px;" :readonly="true" v-model="singleAlarmData[0][item.key]"></i-input>
                        <i-input v-else-if="item.key == 'contentStr'" :readonly="true" type="textarea" :autosize="{minRows: 2,maxRows: 3}" style="width:330px;" v-model="singleAlarmData[0][item.key]"></i-input>
                        <i-input v-else v-model="singleAlarmData[0][item.key]" style="width:330px;" placeholder="请输入确认人..."></i-input>
                    </FormItem>
                </Form>
            </Card>
            <div slot="footer" style="display:flex;justify-content: flex-end;">
                <Button style="width:70px;" size="large" long  @click="unConfirmAlarm">{{ unConfirmText }}</Button>
                <Button style="width:70px;" type="primary" size="large" long  @click="confirmAlarm">{{ confirmText }}</Button>
            </div>
        </Modal>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<style>
    .paging{
        float:right;
        margin-top:5px;
        white-space: nowrap;
        display:flex;
    }
    .header {
        --unbgColor : #fff;
        --unColor   : #000;
        --bgColor   : #fff;
        --Color     : #000;
        --thColor :  #f8f8f9;
        --tableColor : #f8f8f9;
        --borderColor : #000;
        --textColor:#000;
    }
    /*未经确认*/
    .demo-table-unConfirm-row td {
        color : var(--unColor); 
        background-color : var(--unbgColor);
    }
    /*已经确认*/
    .demo-table-confirm-row td {
        color : var(--Color);
        background-color : var(--bgColor);
    }
    .header .ivu-table th{
        background-color: var(--thColor);
        color:var(--textColor)
    }
    .header .ivu-table{
        background-color:var(--tableColor);
    }
    
    .header .ivu-page-next{
        background-color:var(--tableColor);
    }
    .header .ivu-page-prev{
        background-color:var(--tableColor);
    }
    .header .ivu-page-item{
        background-color:var(--tableColor);
    }
    .header  .ivu-table:after{
        background-color:transparent
    }    
    .header  .ivu-table:before{
        background-color:transparent
    }
    .clearfix:before,.clearfix:after {  
        content:"";  
        display:table;  
    }  
    /*用于清除浮动*/ 
    .clearfix:after{  
        clear:both;  
    }  
    .clearfix{  
        *zoom:1;/*IE/7/6*/ 
    }
    /* 边框为其进行隐藏 */
    .header  .ivu-table-wrapper{
        border-color : var(--borderColor);
    }
    .header  .ivu-table th{
          border-color : var(--borderColor);
    } 
    .header  .ivu-table td{
        border-color : var(--borderColor);
    }
    .v-transfer-dom .vertical-center-modal{
        z-index: 9999 !important;
    }
    .header .ivu-spin-fix{
        background-color : var(--bgColor);
    }
    .ivu-table-wrapper-with-border{
        border-right:1px solid ;
    }
</style>
<script>
import Print from 'print-js'
import Vue from "vue";
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives); 
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        };
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        };
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(!this.alarmType){
            this.UpDateData();
        }
        if (this.$store.state.system.$.languageName == "ch") {
            locale(cn);
        } else {
            locale(en);
        }
    },
    mounted(){
        this.func();
        //报警后台推送监听
        if(this.alarmPush == true){
            //判断如果有pspace后台预警，给予组件静音
            var serOpen = false;
            for(var k in this.$store.state.system.$.jsonSysRootConfig.backstage){
                if(this.$store.state.system.$.jsonSysRootConfig.backstage[k].config.fctype == "fvAlarmServer"){
                    this.$refs.audio.muted = true;
                    var serOpen = true;
                }
            }
            if(serOpen==false){
                this.$Message.info("无预警后台推送,请前往配置配置pspace后台预警！")
            }
            this.$store.state.system.$.dbCom.socketClient.on('message', (msg)=>{
                switch(msg.head){
                    case "backAlarmServer":
                        if(msg.message.data.length>0){
                            var result = msg.message.data;
                            this.DataList = result;
                            this.loading = false;
                            // 防止数据不断变化
                            // this.openAudio(result);
                            // 对获取到的实时数据进行排序
                            let sortData = result.sort(this.NumAlarmSort);
                            this.processingData(sortData);
                            var alarmList = [];
                            for(var k in result){
                                if(result[k].haveAcked == "未确认"){
                                    alarmList.push(result[k])
                                }
                            }
                            if(alarmList.length>0){
                                this.$refs.audio.play();
                            }else{
                                this.$refs.audio.pause();
                            }
                        }
                    break;
                }
            })
        }
    },
     watch: {
        alarmData(val) {
            for (let index = 0; index < val.length; index++) {
                const element = val[index];
                if (element.haveAcked !== "确认" || element.haveAcked!=="无需确认") {
                this.arr.splice(index, 1);
                }
            }
        },
        
    },
    data(){
        return {
            //竖向边框
            showBorder:this.showBorder,
            loading: false,
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            columns : [],
            column : [],
            alarmData : [],
            singleAlarmData : [],
            isFilter: false,      // 是否需要过滤数据
            alarmModal:false,     // 确认报警弹窗
            queries:[],           //过滤字段
            queryList:[],
            playFlag:true,
            openFlag: true,
            arr: [],         //过滤列
            tableHeight : 0,
            pageSize : 5,
            currentPage : 1 ,          // 当前页数
            dataCount:0,        // 总条数
            alarmModalTitle: this.fvSystemApi.getResource("确认报警") || "确认报警",//确认报警
            unConfirmText: this.fvSystemApi.getResource("取消") || "取消",//取消
            confirmText: this.fvSystemApi.getResource("确定") || "确定",//取消
            seletRowData: {}
        }
    },
    methods:{
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            if(!this.alarmType) return;
            var curTime = new Date().getTime();
            if(curTime - this.lastTime < this.alarmstepTime) return;
            this.lastTime = curTime;
            if(this.alarmPush == true) return;//报警推送标记勾选不用实时调取
            this.UpDateData();
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.domStyle.fontSize = (12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy + "px";  
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
            this.tableHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
            
            // this.showBorder
            this.setColumnsData();
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：获取当前报警类型
        */
        GetDateAlarmType(){
            var str = "";
            var backNum 
            if(this.alarmType){
                str = "实 时 报 警";
                backNum = 1;
            }else{
                str = "历 史 报 警";
                backNum = 0;
            }
            //注释掉，暂时不知道用途
            // this.$Notice.success({
            //     title: '当前报警类型为:',
            //     desc: `${str}`,
            //     render: h => {
            //         return h('h1', [
            //             `${str}`
            //         ])
            //     }
            // });
            return backNum;
        },
        /*
            参数：value 修改的时间
            作用：修改结束时间
        */
        SetEndTime(value){
            this.endTime = value;
        },
        /*
            参数：value 修改的时间
            作用：修改开始时间
        */
        SetStartTime(value){
            this.startTime = value;
        },
        /*
            参数：value 修改的时间间隔
            作用：修改查询间隔
        */
        SetStepTime(value){
            this.alarmstepTime = value;
        },
        /*
            参数：value 修改报警类型的值
            作用：切换报警类型
        */
        UpDateAlarmType(value){
            this.currentPage = 1;
            //切换实时或者历史需要给过滤关闭
            this.isFilter = false;
            //初始化过滤条件
            this.queries = [];
            this.queryList = [];
            value == "0" ? this.alarmType = false : this.alarmType = true;
            // 类型是历史，则手动调用
            if(value == 1){
                this.UpDateData();
            };
        },
        /*
            参数：condition 过滤条件 column 需要过滤的列
            作用：对报警信息进行过滤显示
        */
        AlarmFilter(condition,column){
            //时间需要转换
            var arr = condition.split(".");
            condition = arr.join("/");
            this.isFilter = true;
            if(condition.length < 1){
                this.isFilter = false;
            }
            if(column != ""){
                if(!~this.alarmLayout.findIndex(element => element === column)){
                    this.$Message.info("请核对查询的列是否存在")
                    this.isFilter = false;
                }
            }
            this.queries = `${condition}`;
            this.queryList = `${column}`;
            //this.UpDateData();
        },
        /*
            参数：无
            作用：打印表单
        */
        Print(){
             if(this.nav()){
                this.$Message.warning("手机以及ipad不支持表单打印!")
            }else{
                this.$Spin.show();
                var columnName = [];
                for(var k in this.jsonData[0]){
                    columnName.push(k);
                }
                Print({
                    printable : this.jsonData,
                    properties : columnName,
                    type: 'json',
                        onLoadingEnd: () => {
                        this.$Spin.hide();
                    }
                })
            }
        },
        /*
            参数：无
            作用：更新数据
        */
        UpDateData(){
            if(this.loading){
                // this.$Message.warning("请求中,请勿重复点击！");
                return;
            };
            
            var data = {}
            if(this.alarmPush != true){
                if(this.alarmType){
                    // 实时
                    data = {
                        "head": "dataLayer",
                        "message" : {
                            "head" : "getSourceAlarm",
                            "message" : {
                                "nodeName" : ""
                            }
                        }
                    }
                }else{
                    this.loading = true;
                    // 历史
                    data = {
                        "head": "dataLayer",
                        "message" : {
                            "head" : "getSourceHisAlarm",
                            "message" : {
                                "startTime" : new Date(this.startTime).getTime(),
                                "endTime" : new Date(this.endTime).getTime(),
                                "nodeName" : ""
                            }
                        }
                    }
                }
                if(this.isRegion != 0){
                    // 区域查询
                    data["message"]["message"]["nodeName"] = this.regionName;
                }
                this.fvSystemApi.getAlarmData(data).then((result) => {
                    this.DataList = result;
                    this.loading = false;
                    // 防止数据不断变化
                    // this.openAudio(result);
                    // 对获取到的实时数据进行排序
                    let sortData = result.sort(this.NumAlarmSort);
                    this.processingData(sortData);
                    var alarmList = [];
                    for(var k in result){
                        if(result[k].haveAcked == "未确认"){
                            alarmList.push(result[k])
                        }
                    }
                    if(alarmList.length>0){
                        this.$refs.audio.play();
                    }else{
                        this.$refs.audio.pause();
                    }
                }).catch((error) => {
                    this.loading = false;
                    console.log(error);
                })
            }
           
        },
        NumAlarmSort(a, b) {
            return b.startTime - a.startTime;
        },
        SetMuffle() {
            if (!this.$refs.audio.paused) {
                this.$refs.audio.pause();
            }
        },
        /*------------------------------------脚本在上---------------------------------------------*/
        /*------------------------------------方法在下---------------------------------------------*/
        //全部确认
        AckAll(){
            var list = [];
            for(var i in this.DataList){
                if(this.DataList[i].haveAcked == "未确认"){
                    list.push(this.DataList[i].alarmId)
                }
            }
            var data = {
                    "head": "dataLayer",
                    "message" :  {
                        "head" : "makeConfirmSourceAlarm",
                        "message" : {
                            "head" : "makeConfirm Alarm",
                            "ackName" : "admin",
                            "alarmIds" : list
                        }
                    }
                }
                this.fvSystemApi.getAlarmData(data)
                .then((result) => {
                    this.UpDateData();
                })
                .catch((error) => {
                    this.$Message.error("确认报警失败")
                })
                // 点击确认后先去修改颜色和数据
                // this.alarmData.splice(this.seletRowData.rowIndex, 1, this.seletRowData.rowData);
                // this.alarmData[this.seletRowData.rowIndex].haveAcked = "修改中···";
                // this.$refs.tables.rowClassName(this.seletRowData.rowData,this.seletRowData.rowIndex);
        },
        //选中确认
        AckSingle(){
           
        },
        //获取所有实时的报警数据量
        ALLNUMBER(){
            return this.DataList.length;
        },
        //获取所有未确认报警数量
        LENUMBER(){
            var list = [];
            for(var i in this.DataList){
                if(this.DataList[i].haveAcked == "未确认"){
                    list.push(this.DataList[i].alarmId)
                }
            }
            return list.length;
        },
        /*
            参数：data 数据
            作用：是否开启声音
        */
        audioPlay() {
            if (this.$refs.audio.paused) {
                // this.$refs.audio.pause();
                // this.$refs.audio.load();
                this.$refs.audio.play();
                this.playFlag = false;
                this.openFlag = false;
                // }
            } else {
                // this.$refs.audio.pause();
                this.$refs.audio.load();
                this.$refs.audio.play();
            }
        },
       playEndedHandler() {
            let a = this.arr.pop();
            this.arr.unshift(a);
            this.$refs.audio.src = a;
            this.$refs.audio.play();
        },
        openAudio(){
            if(this.openSoundAudio == 1){
                var audioSrc =debugFWebView + this.$store.state.system.$.projectName + "/Audio/" + this.audioFile;
                this.$refs.audio.src = audioSrc;
            }
        },
        /*
            参数：index 当前页数
            作用：切换分页
        */  
        changepage(index){
            if(this.temporaryData != undefined){
                this.currentPage = index;
                this.dataCount = this.temporaryData.length;
                var _start = (index - 1) * this.pageSize;
                var _end   = index * this.pageSize;
                var data = this.temporaryData.slice(_start,_end);
                this.showAlarmData(data);
            }
        },
        /*
            参数：data 转换为展示数据
            作用：为实时数据的展示进行转换
        */
        processingData(data){
            data.forEach((item) => {
                item.startTime = new Date(item.startTime).format("yyyy/MM/dd hh:mm:ss");
                item.endTime == 0 ? item.endTime = "-  -" : item.endTime = new Date(item.endTime).format("yyyy/MM/dd hh:mm:ss");
                if(item.valueStr.indexOf("ps")>-1){
                    if(item.valueStr.indexOf("TRUE")>-1){
                        item.valueStr = "true";
                    }else if(item.valueStr.indexOf("FALSE")>-1){
                        item.valueStr = "false";
                    }else{
                      item.valueStr = item.valueStr;
                    }
                }else{
                    item.valueStr = Number(item.valueStr).toFixed(3);
                }
                item.name = this.fvSystemApi.getResource(item.name) || item.name;
                item.desc = this.fvSystemApi.getResource(item.desc) || item.desc;
                if(item.needAck){
                    var time = new Date(item.ackTime).format("yyyy/MM/dd hh:mm:ss") + (this.fvSystemApi.getResource(" 已确认") || " 已确认");
                    item.haveAcked = item.haveAcked ? time : (this.fvSystemApi.getResource("未确认") || "未确认");
                }else{
                    item.haveAcked = this.fvSystemApi.getResource("无需确认") || "无需确认";
                }
                switch(item.topic){
                    case 1:
                        item.topic = this.fvSystemApi.getResource("质量戳改变") || "质量戳改变";
                    break;
                    case 2:
                        item.topic = this.fvSystemApi.getResource("值改变") || "值改变";
                    break;
                    case 4:
                        item.topic = this.fvSystemApi.getResource("越高限") || "越高限";
                    break;
                    case 8:
                        item.topic = this.fvSystemApi.getResource("越高高限") || "越高高限";
                    break;
                    case 16:
                        item.topic = this.fvSystemApi.getResource("越低限") || "越低限";
                    break;
                    case 32:
                        item.topic = this.fvSystemApi.getResource("越低低限") || "越低低限";
                    break;
                    case 64:
                        item.topic = this.fvSystemApi.getResource("变化率报警") || "变化率报警";
                    break;
                    case 128:
                        item.topic = this.fvSystemApi.getResource("偏差报警") || "偏差报警";
                    break;
                }
            })
            if(this.isFilter){
                var data = this.filterMethod(data);
            }
            this.temporaryData = data;
            var page = Math.floor((this.tableHeight - 32)/40)
            this.pageSize = page > 1 ? page : 1;
            this.changepage(this.currentPage);
        },
        /*
            参数：data 展示用数据
            作用：将数据进行展示
        */
        showAlarmData(data){
            this.alarmData = data;
            this.jsonData = JSON.parse(JSON.stringify(data));
            this.disposePrintData(this.jsonData);
        },
        /*
            参数：无
            作用：更新表头
        */
        setColumnsData(){
            if(this.alarmLayout == null) return  
            this.columns.splice(0);
            this.alarmLayout.forEach((item) => {
                item = item.split(':');
                let obj = {
                    title : item[0],
                    align : "center",
                    resizable :true,
                };
                if(item[0] == "序号" || item[0] == "Serial Number"){
                    obj.type = 'index';
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "点ID" || item[0] == "Point ID"){
                    obj.key = "tagId";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "报警ID" || item[0] == "Alarm ID"){
                    obj.key = "alarmId";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "报警点" || item[0] == "Alarm Point"){
                    obj.key = "name";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "描述" || item[0] == "Description"){
                    obj.key = "desc";
                    obj.tooltip = true;
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "报警类型" || item[0] == "Alarm Type"){
                    obj.key = "topic";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "值" || item[0] == "Value"){
                    obj.key = "valueStr";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "开始时间" || item[0] == "Starting Time"){
                    obj.key = "startTime";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "结束时间" || item[0] == "End Time"){
                    obj.key = "endTime";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "确认" || item[0] == "OK"){
                    obj.key = "haveAcked";
                    obj.tooltip = true;
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "报警内容" || item[0] == "Alarm Content"){
                    obj.key = "contentStr";
                    obj.tooltip = true;
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "报警级别" || item[0] == "Alarm Level"){
                    obj.key = "level";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "确认人" || item[0] == "Confirmor"){
                    obj.key = "ackContentStr";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                this.columns.push(obj);
            })
            var tableWidth = 0;
            this.columns.forEach((el) =>{
                tableWidth += el.width; 
            })
            if(tableWidth < this.realWidth){
                this.columns.forEach((el) => {
                    delete el.width;
                })
            }
        },
        /*
            参数：无
            作用：控制class样式绑定为变量
        */
        func(){
            if(this.transparent == 1){
                this.transparent = true;
            }else{
                this.transparent = false;
            }
            var n = 0;
            this.transparent ? n = 0.2 : n = 1; 

            //背景颜色
            this.$refs.mycolor.style.setProperty("--thColor",this.colorRgba(this.tableBackgroundColor,n));
            //字体颜色
            this.$refs.mycolor.style.setProperty("--textColor",this.tableTextColor);
            this.$refs.mycolor.style.setProperty("--tableColor",this.transparent ? "transparent" : "#f8f8f9");
            this.$refs.mycolor.style.setProperty("--borderColor",this.borderColor);

            this.$refs.mycolor.style.setProperty("--Color",this.colorTextType[1]);//已确认字体
            this.$refs.mycolor.style.setProperty("--bgColor",this.colorRgba(this.colorType[1],n));//已确认背景

            this.$refs.mycolor.style.setProperty("--unbgColor",this.colorRgba(this.colorType[0],n));//未确认背景
            this.$refs.mycolor.style.setProperty("--unColor",this.colorTextType[0]);//未确认字体
            this.openAudio();
        },
        /*
            参数：row 当前数据 index  下标
            作用：根据条件改变行内颜色
        */
        rowClassName(row,index){
            if((row.haveAcked.indexOf("已确认") != -1) || row.haveAcked.indexOf(this.fvSystemApi.getResource("已确认")) != -1){
                return 'demo-table-confirm-row';
            }else if(row.haveAcked == "未确认" || row.haveAcked == this.fvSystemApi.getResource("未确认")){
                return 'demo-table-unConfirm-row';
            }else{
                return ''
            }
        },
        /*
            参数：row 当前数据 index 下标
            作用：双击表单事件
        */
        doblueClick(row,index){
            // 存储下双击过的数据
            this.seletRowData = {
                rowData: row,
                rowIndex: index
            };
            this.singleAlarmData = [];
            this.column = [];
            if(row.haveAcked == "未确认" || row.haveAcked == this.fvSystemApi.getResource("未确认")){
                row.ackContentStr = this.fvSystemApi.getCurrentUser();
                row.ackTime = new Date();
                row.ackUserId = 0;
                this.singleAlarmData.push(row);
                for(var i = 1 ; i < this.columns.length ; i++){
                    var item = this.columns[i]
                    var key = item.key
                    if(key){
                        this.column.push(item);
                    }
                }
                if(row.alarmAudio){
                    this.column.push({

                    });
                }
                this.alarmModal = true;
            }
        },
        /*
            参数：无
            作用：确认报警人
        */
        confirmAlarm(){
            this.alarmModal = false;
            if(this.singleAlarmData[0].ackContentStr != ""){
                var data = {
                    "head": "dataLayer",
                    "message" :  {
                        "head" : "makeConfirmSourceAlarm",
                        "message" : {
                            "head" : "makeConfirm Alarm",
                            "ackName" : this.singleAlarmData[0].ackContentStr,
                            "alarmIds" : [parseInt(this.singleAlarmData[0].alarmId)]
                        }
                    }
                }
                this.fvSystemApi.getAlarmData(data)
                .then((result) => {
                    this.UpDateData();
                })
                .catch((error) => {
                    this.$Message.error("确认报警失败")
                })
                // 点击确认后先去修改颜色和数据
                this.alarmData.splice(this.seletRowData.rowIndex, 1, this.seletRowData.rowData);
                this.alarmData[this.seletRowData.rowIndex].haveAcked = "修改中···";
                this.$refs.tables.rowClassName(this.seletRowData.rowData,this.seletRowData.rowIndex);
                
            }else{
                this.$Message.error("确认人不能为空！")
            }
        },
        /*
            参数：无
            作用：取消确认报警弹窗
        */
        unConfirmAlarm(){
            this.alarmModal = false;
        },
        /*
            参数：data 需要过滤的数据
            作用：将数据进行过滤展示
        */
        filterMethod(data){
            var filterData = [];
            if(data.length != 0){
                // 查询固定列
                if(this.queryList.length != ""){
                    data.forEach((item) => {
                        this.columns.forEach((list) => {
                            if(list.title == this.queryList){
                                if(item[list.key].indexOf(this.queries) != -1){
                                    filterData.push(item);
                                }
                            }
                        })
                    })
                }else{
                    // 查询所有列
                    data.forEach((item) => {
                        var overCycle = true;
                        this.columns.forEach((list) => {
                            if(overCycle){
                                if(list.key){
                                    // 把数据转换为字符串
                                    var str = item[list.key] + ""
                                    if(str.indexOf(this.queries) != -1){
                                        filterData.push(item);
                                        overCycle = false;
                                    }
                                }
                            }
                        })
                    })
                }
            }
            return filterData;
        },
        /*
            参数：data 需要转换的数据
            作用：将数据转化为打印格式
        */
        disposePrintData(data){
            var reg = /^[a-zA-Z]+$/;
            data.forEach((item) => {
                this.columns.forEach((list) => {
                    if(list.key){
                        for(var k in item){
                            if(k == list.key){
                                item[list.title] = item[k];
                            }
                        }
                    }
                })
                for(var z in item){
                    if(reg.test(z)){
                        delete item[z];
                    }
                }
            })
        },
        /*
            参数：无
            作用：判断是否支持导出的设备
        */  
        nav(){
            var ua = navigator.userAgent;
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            if(isIphone || isAndroid || isMobile){
                return true;
            }else{
                return false;
            }
        },
        /*
            参数：str 十六位制颜色 n 透明度
            作用：将十六位制的颜色转为rgba
        */
        colorRgba (str,n){
            if(!str) return;
            //十六进制颜色值的正则表达式
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            var sColor = str.toLowerCase();
            //十六进制颜色转换为RGB格式  
            if(sColor && reg.test(sColor)){  
                if(sColor.length === 4){
                    var sColorNew = "#";  
                    for(var i=1; i<4; i+=1){  //例如：#eee,#fff等
                        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));     
                    }  
                    sColor = sColorNew;  
                }  
                //处理六位颜色值  
                var sColorChange = [];  
                for(var i=1; i<7; i+=2){  
                    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));    
                }
                return "rgba(" + sColorChange.join(",") + ","+n+")"; 
            }else{  
                return sColor;    
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvAlarmReport/fvAlarmReport.vue